<template>
  <v-container fluid class="docForm">
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Close Accounts</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-card-text v-if="closingData && closingData.length > 0">
        <v-row>
          <div
            class="mt-2 ml-3 float-right"
            style="font-size: 20px; font-weight: bold"
          >Date: {{ date }}</div>
        </v-row>

        <v-row class="subtitle-2 text--primary">
          <v-col cols="6">
            <v-data-table :mobile-breakpoint="0" :headers="headers" :items="closingData">
              <template v-slot:item.amount="{ item }">
                <span>{{ item.amount.toLocaleString()}}</span>
              </template>
              <template v-slot:item.total="{ item }">
                <span
                >{{ (item.denomination * item.amount).toLocaleString() }}</span>
              </template>
            </v-data-table>
          </v-col>

          <v-col cols="6">
            <div
              style="font-size: 18px; font-weight: bold"
            >Total Closing: {{ TotalClosing.toLocaleString() }}</div>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text v-else>
        <v-row>
          <v-col cols="12" md="4">
            <span
              v-if="dateReadonly == 'Y'"
              style="font-weight: bold; font-size: 16px"
            >Date: {{ date }}</span>
            <DatePicker v-else @date="setDate" :myDate="date" :title="`Date`" ref="dateRef"></DatePicker>
          </v-col>
        </v-row>

        <v-row class="subtitle-2 text--primary">
          <v-col cols="6">
            <v-data-table :mobile-breakpoint="0" :headers="headers" :items="accounts">
              <template v-slot:item.name="{ item }">
                <span style="font-weight: bold; font-size: 20px">{{ item.name }}</span>
              </template>

              <template v-slot:item.amount="{ item }">
                <v-text-field type="number" outlined v-model="item.amount" style="width: 150px"></v-text-field>
              </template>

              <template
                v-slot:item.total="{ item }"
              >{{ (item.denomination * item.amount).toLocaleString() }}</template>
            </v-data-table>
          </v-col>

          <v-col cols="6">
            <div
              style="font-size: 20px; font-weight: bold"
            >Total Closing: {{ total.toLocaleString() }}</div>
            <v-btn class="primary mt-3" :loader="loader" :disabled="loader" @click="closeAccounts">
              <v-icon left>mdi-content-save</v-icon>Close Accounts
            </v-btn>
          </v-col>
        </v-row>

        <snackbar ref="snackbar"></snackbar>
      </v-card-text>
    </v-card>
  </v-container>
</template>
  
  <script>
export default {
  computed: {
    activeStore() {
      return localStorage.getItem("store_id");
    },
    total() {
      let total = 0;
      if (typeof this.accounts != "undefined" && this.accounts.length > 0) {
        return this.accounts
          .map(item => {
            let amount = 0;
            if (item.amount) {
              amount = parseInt(item.amount) * parseInt(item.denomination);
            }

            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    }
  },
  data: () => ({
    search: "",
    loader: false,
    status: false,
    dateReadonly: "N",
    date: new Date().toISOString().substr(0, 10),
    menu1: false,
    accounts: [],
    closingData: [],
    TotalClosing: 0,
    dets: [],
    headers: [
      { text: "Title", value: "denomination", sortable: false },
      { text: "Amount", value: "amount", sortable: false },
      { text: "Total", value: "total", sortable: false }
    ],
    expenses: [],
    TotalExpenses: null
  }),
  methods: {
    setDate(date) {
      this.date = date;
      this.getDenominitions();
    },
    closeAccounts() {
      if (this.total == 0) {
        this.$refs.snackbar.show("Please fill the respective denominations", "red");
        return;
      }

      const data = {};
      var accountsData = [];
      for (const account of this.accounts) {
        var closingAmount = 0;
        if (account.amount) {
          closingAmount = account.amount;
        }
        accountsData.push({
          amount: parseInt(closingAmount),
          denomination: parseInt(account.denomination)
        });
      }

      data.rows = accountsData;
      data.date = this.date;
      data.store_id = parseInt(this.activeStore);

      const url = "/close-accounts";
      const self = this;
      self.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            self.getDenominitions();
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        }).finally(() => {
          self.loader = false;
        });
    },
    getDenominitions() {
      const data = {};
      data.date = this.date;
      data.store_id = parseInt(this.activeStore);
      const url = "/denominations";
      const self = this;
      this.$store.commit("loader", true);
      this.$store
        .dispatch("post", { url, data})
        .then(res => {
          if (res.ResultCode == 1200) {
            this.status = res.ResponseData.closingStatus;
            var denominations = res.ResponseData.denominations;
            self.closingData = res.ResponseData.closingData;
            self.TotalClosing = res.ResponseData.totalClosing;

            for (const denomination of denominations) {
              var details = {
                denomination: denomination.currency_value,
                amount: null
              };

              // check if denomination exist in the accounts
              var found = self.accounts.find(
                account => account.denomination == denomination.currency_value
              );

              if(!found) {
                self.accounts.push(details);
              }
             
            }

            self.$store.commit("loader", false);
          } else {
           // this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    this.getDenominitions();
  }
};
</script>